<template>
    <v-autocomplete
        :items="items"
        :loading="listLoading"
        :search-input.sync="search"
        :value="value"
        @input="updateStockName"
        cache-items
        label="銘柄選択"
    ></v-autocomplete>
</template>

<script>
import axios from 'axios';

export default {
    data () {
        return {
            items: [],
            search: null,
            select: null,
            listLoading: false,
        }
    },
    name: 'StockCodeAutocomplete',
    watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val);
      },
    },
    props: {
      value: {
        type: String
      },
    },
    methods: {
      querySelections(v) {
        this.listLoading=true;
        axios
          .get('/api/v1/stocks/list')
          .then(response => {
            this.listLoading = false;
            this.items=response.data;
          });
      },
      updateStockName(e) {
        const vm = this;
        vm.$emit('updateStockName', e);
      },
    }
}
</script>